import RegistrationModal from '@/components/top/auth/registration-modal/RegistrationModal.vue';
import { createPinia } from 'pinia';
import { createApp, ref } from 'vue';

const mountEl = document.getElementById('registration-modal-container');

if (mountEl) {
  const app = createApp({
    components: { RegistrationModal },
    setup() {
      const isOpen = ref(false);
      const handleSubmit = async (): Promise<void> => {
        await Promise.resolve();
      };
      return { isOpen, handleSubmit };
    },
    template: '<RegistrationModal v-model="isOpen" :on-submit="handleSubmit" />',
  });
  const pinia = createPinia();
  app.use(pinia);
  app.mount(mountEl);
}
